import React from "react";
import { ExternalLink, GraduationCap } from "lucide-react";

export type ResourceCardProps = {
  title: string;
  description: string;
  ctaLabel?: string;
  href?: string;
  onClick?: () => void;
  icon?: React.ReactNode;
  className?: string;
};

export function ResourceCard({
  title,
  description,
  ctaLabel = "Launch",
  href,
  onClick,
  icon,
  className = "",
}: ResourceCardProps) {
  const Cta = href ? (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="inline-flex items-center gap-2 rounded-lg bg-ring px-4 py-2 text-sm font-medium text-white transition leading-4 hover:bg-white hover:text-black focus:outline-none focus:ring-2 focus:ring-focus-ring focus:ring-offset-2 focus:ring-offset-neutral-900"
      aria-label={`${ctaLabel} ${title}`}
    >
      {ctaLabel}
      <ExternalLink className="h-4 w-4" aria-hidden="true" />
    </a>
  ) : (
    <button
      type="button"
      onClick={onClick}
      className="inline-flex items-center gap-2 rounded-lg bg-ring px-4 py-2 text-sm font-medium text-white transition leading-4 hover:bg-white hover:text-black focus:outline-none focus:ring-2 focus:ring-focus-ring focus:ring-offset-2 focus:ring-offset-neutral-900"
      aria-label={`${ctaLabel} ${title}`}
    >
      {ctaLabel}
      <ExternalLink className="h-4 w-4" aria-hidden="true" />
    </button>
  );

  return (
    <div
      className={
        `relative max-w-sm rounded-lg bg-neutral-900 p-6 text-white shadow-lg ${className}`
      }
      role="region"
      aria-label={`${title} resource card`}
    >
      <div className="mb-4 text-white/90">
        {icon ?? <GraduationCap strokeWidth={1.5} aria-hidden="true" />}
      </div>
      <h3 className="mb-2 text-xl font-semibold leading-[23px]">{title}</h3>
      <p className="mb-4 text-sm leading-[19px] text-neutral-300">{description}</p>
      {Cta}
    </div>
  );
}